import { Typography } from "antd";
import React from "react";
import GoogleMapReact from "google-map-react";
import { theme } from "../../../../utils/theme";

const Marker = () => (
  <div
    style={{
      position: "absolute",
      transform: "translate(-50%, -100%)",
      cursor: "pointer",
    }}>
    <div
      style={{
        position: "relative",
        width: "40px",
        height: "40px",
      }}>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          background: "white",
          borderRadius: "50% 50% 50% 0",
          transform: "rotate(-45deg)",
          boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
        }}
      />
      <div
        style={{
          position: "absolute",
          width: "80%",
          height: "80%",
          top: "10%",
          left: "10%",
          borderRadius: "50%",
          overflow: "hidden",
          transform: "rotate(45deg)",
        }}>
        <img
          src="/hemen_personel_icon.png"
          alt="location marker"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transform: "rotate(-45deg)",
          }}
        />
      </div>
    </div>
  </div>
);

const JobLocation = ({ lat, long, marginTop = 40 }) => {
  const mapCenter = {
    lat: parseFloat(lat),
    lng: parseFloat(long),
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: marginTop,
        }}>
        <div
          style={{
            width: "4px",
            height: "30px",
            backgroundColor: theme.primaryColor,
            marginRight: "12px",
          }}
        />
        <Typography.Title
          level={2}
          style={{
            margin: 10,
            padding: 0,
            fontSize: "24px",
            fontWeight: "bold",
          }}>
          İlan Konumu
        </Typography.Title>
      </div>
      <div style={{ height: 300, width: "100%" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY }}
          defaultCenter={mapCenter}
          defaultZoom={14}>
          <Marker lat={mapCenter.lat} lng={mapCenter.lng} />
        </GoogleMapReact>
      </div>
    </>
  );
};

export default JobLocation;
